import {createContext} from "react";
import {useInitialData} from "../hooks/useInitialData";

const ChatContext = createContext({} as ReturnType<typeof useInitialData>);
export const ChatDataProvider = ChatContext.Provider;

export default ChatContext;